import cssVariables from 'tfs.css-variables'

export default {
  'drop-down': {
    zIndex: 2,
    position: 'absolute',
    top: '1rem',
    left: 0,

    borderRadius: '0.8rem',
    boxShadow: '0 0.2rem 3px rgba(0, 0, 0, 0.15)',
    backgroundColor: cssVariables.colorWhite,
    '&::before': {
      content: '',
      position: 'absolute',
      left: '1.3rem',
      bottom: '100%',
      width: 0,
      height: 0,
      borderLeft: '0.8rem solid transparent',
      borderRight: '0.8rem solid transparent',
      borderBottom: `0.9rem solid ${cssVariables.colorWhite}`,
    },
  },
  hidden: {
    display: 'none',
  },
  list: {
    maxHeight: '13rem',
    overflowY: 'auto',
    margin: 0,
    padding: '0.5rem 0',
  },
  'list-item': {
    display: 'block',
    margin: 0,
    padding: '0.5rem 1rem',

    listStyleType: 'none',
    cursor: 'default',

    "&[data-active='true']": {
      backgroundColor: cssVariables.colorGrayE,
    },
  },
}
